import $ from 'jquery';
import { trace } from 'rytm-helpers'
import RytmWebflow from 'rytm-webflow'
import Gallery from "blueimp-gallery";
import { affixFafix, updateAffix } from './affix-fafix'
import { initHeaderScroll, updateHeaderHeight } from './header-scroll';
import { updateLinks } from './linksFix'
import { updateLocomotiveScroll } from '../scroll';

// BlueImp Gallery click
const onBlueimpGalleryLinkClick = (e) => {
  e.preventDefault();
  let blueimpLinks = document.querySelectorAll('[data-gallery]');  
  let selector = e.currentTarget.getAttribute('data-gallery');
  trace("blueimp gallery selector", selector)
  if (!selector) {
    return
  }
  let link = e.currentTarget;
  let options = {
    container: selector,
    event: e,
    index: link,
    titleElement: 'header'
  }
  Gallery(blueimpLinks, options);
}
export const blueimpGalleryDestroy = () => {
  document.body.style.overflow = "visible"
}


const onCollapseShow = (e) => {
  const trigger = getCollapseTrigger(e.target.id)
  if (trigger.dataset.labelCollapse) {
    trigger.innerHTML = trigger.dataset.labelCollapse
  }
}
const onCollapseHide = (e) => {
  const trigger = getCollapseTrigger(e.target.id)
  if (trigger.dataset.labelExpand) {
    trigger.innerHTML = trigger.dataset.labelExpand
  }
}
const onCollapseShown = (e) => {
  // update locomotive scroll
  updateLocomotiveScroll()
}
const onCollapseHidden = (e) => {
  // update locomotive scroll
  updateLocomotiveScroll()
}
const getCollapseTrigger = (id) => {
  let trigger
  if (id) {
    trigger = document.querySelector("a[href='#" + id + "']")
  }
  return trigger
}

const onAsBackClick = (e) => {
  e.preventDefault()
  e.stopPropagation()
  // console.log("on as back click", RytmWebflow.aswap.dispatcher)
  RytmWebflow.aswap.dispatcher.back()
}


// ### Window update
const windowUpdateTimer = false;
export const windowUpdate = (e) => {
  updateLinks()
  updateAffix()
  updateHeaderHeight()
};


export const removeReCaptchaBadge = () => {
  const list = [...document.querySelectorAll(".grecaptcha-badge")]
  list.forEach((el) => {
    const parentDiv = el.parentNode
    parentDiv.removeChild(el)
    // remove DIV
    parentDiv.parentNode.removeChild(parentDiv)
  })
}

// ### INIT
export const initCommon = () => {
  affixFafix()
  initHeaderScroll()
  $('body').on('click', 'a[data-gallery]', onBlueimpGalleryLinkClick);
  $('body').on('click', 'a.as-back', onAsBackClick);
  // collapse
  document.documentElement.addEventListener("show.bs.collapse", onCollapseShow)
  document.documentElement.addEventListener("shown.bs.collapse", onCollapseShown)
  document.documentElement.addEventListener("hide.bs.collapse", onCollapseHide)
  document.documentElement.addEventListener("hidden.bs.collapse", onCollapseHidden)
  $(document).on('DOMContentLoaded load', windowUpdate);
  $(window).on('resize', windowUpdate);
  // window update
  windowUpdate();
};

